import { currentIdentity } from "@/entities/user"

export function resolveOwner(): Promise<string | null> {
	return currentIdentity().resolveId()
}
